/*
 * i18n module — ported from CustomerPortalClient.js.
 * Backend-driven translations: fetched via get_tokens(), stored in dictionary.
 * Missing keys auto-register to EN-US.
 */

import axios from "axios";
import { toast } from "sonner";
import { base_url } from "./templating";
import { dictionary, dataCtx, staticData } from "./state";
import type { CustomerPortalClient } from "./client";

let client: CustomerPortalClient;

export const init_i18n = (c: CustomerPortalClient) => {
    client = c;
};

const i18n_url = base_url + "/i18n";

export const _ = (val: string, token: string | null = null): string => {
    if (!val || (staticData as Record<string, unknown>).editEnabled || !dictionary.isLoaded) {
        return val;
    }
    const r = dictionary[(token || val).toLocaleLowerCase()] as string | undefined;
    if (r) {
        return r;
    }
    client.save_token(val, token);
    return val;
};

export const get_languages = async () => {
    return client.get_credentials().then((cred) => {
        return axios.get(i18n_url + "/langs", cred).then((res) => res.data);
    });
};

export const get_tokens = async () => {
    return client.get_credentials().then((cred) => {
        return axios.get(i18n_url + `/lang/${dataCtx.lang}`, cred).then((res) => res.data);
    });
};

export const update_token = async (val: string, token: string) => {
    return client.get_credentials().then((cred) => {
        (cred.headers as Record<string, string>)["Content-type"] = "application/json";
        dictionary[token || val] = val;
        return axios
            .post(
                i18n_url + `/lang/` + dataCtx.lang,
                JSON.stringify({ key: token || val, value: val }),
                cred
            )
            .then((res) => res.data)
            .catch((err) => {
                console.trace(err);
            });
    });
};

export const save_token = async (val: string, token: string | null) => {
    dictionary[token || val] = val;
    return client.get_credentials().then((cred) => {
        (cred.headers as Record<string, string>)["Content-type"] = "application/json";
        return axios
            .post(
                i18n_url + `/lang/EN-US?insert=true`,
                JSON.stringify({ key: token || val, value: val }),
                cred
            )
            .then((res) => res.data)
            .catch((err) => {
                console.trace(err);
            });
    });
};
